import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import imgKamillaFialhoWeb from "shared/assets/images/kamilla-fialho-web.png";
import { useTranslation } from "react-i18next";
import "./CTACampanhasEspeciais.scss";
import { useSelector } from "react-redux";
import { CashAdvanceAvailableEnum } from "shared/enums/CashAdvanceAvailable";
import { useHistory } from "react-router-dom";
import { SpecialCampaignEnum } from "shared/enums/SpecialCampaignEnum";
import {
  artistOriginSpecialCampaign,
  findSpecialCampaign,
  getSpecialCampaign,
  removeSessionSpecialCampaign,
} from "shared/helpers/special-campaign-helpers";
import { ClientSpecialCampaignApprovalEnum } from "shared/enums/ClientSpecialCampaignApprovalEnum";
import { postSpecialCampaignRequest } from "shared/service/StrmService";
import { toast } from "react-toastify";
import Modais from "shared/components/modais";

interface CTAEspecialProps {
  mobile?: boolean;
}

const CardCTAKamillaFialho: React.FC<CTAEspecialProps> = (props) => {
  const { mobile } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const [isSpecialCampaignRequestSent, setIsSpecialCampaignRequestSent] =
    useState(false);
  const [openModalApproved, setOpenModalApproved] = useState<boolean>(false);
  const [openModalNotElegible, setOpenModalNotElegible] =
    useState<boolean>(false);
  const [openModalRequest, setOpenModalRequest] = useState<boolean>(false);
  const [openModalResultRequest, setOpenModalResultRequest] =
    useState<boolean>(false);
  const { cashAdvanceAvailable } = useSelector((state: any) => state.advances);
  const { userArtist } = useSelector((state: any) => state.artists);

  const specialCampaign = getSpecialCampaign(
    userArtist?.specialCampaign,
    SpecialCampaignEnum.KamillaFialho
  );

  const campanhaEspecialKamillaFialho = findSpecialCampaign(
    userArtist?.specialCampaign,
    SpecialCampaignEnum.KamillaFialho
  );

  const title = () => {
    if (specialCampaign?.isParticipating) {
      return t("pages.EstagioArtista.parabensSeloTitulo");
    }
    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Pending
    ) {
      return t("pages.EstagioArtista.recebemosSolicitacaoSeloTitulo");
    }
    return t("pages.EstagioArtista.facaParteSeloTitulo");
  };

  const text = () => {
    if (specialCampaign?.isParticipating) {
      return t("pages.EstagioArtista.parabensSeloTexto");
    }
    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Pending
    ) {
      return t("pages.EstagioArtista.recebemosSolicitacaoSeloTexto");
    }
    return t("pages.EstagioArtista.facaParteSeloTexto");
  };

  useEffect(() => {
    setOpenModalResultRequest(specialCampaign?.shouldNotifyArtist);
  }, [specialCampaign]);

  useEffect(() => {
    const userComFromCampaign = artistOriginSpecialCampaign(
      SpecialCampaignEnum.KamillaFialho
    );

    if (userComFromCampaign && !campanhaEspecialKamillaFialho)
      setOpenModalNotElegible(true);
  }, [campanhaEspecialKamillaFialho]);

  const onClickIniciaProcesso = async () => {
    if (isSpecialCampaignRequestSent) {
      setOpenModalRequest(true);
      return;
    }

    if (
      !isSpecialCampaignRequestSent &&
      specialCampaign?.approval ===
        ClientSpecialCampaignApprovalEnum.NotRequested
    ) {
      const response: any = await postSpecialCampaignRequest({
        specialCampaign: SpecialCampaignEnum.KamillaFialho,
      });
      if (response?.response?.success) {
        setIsSpecialCampaignRequestSent(true);
        setOpenModalRequest(true);
        return;
      } else {
        toast.error<string>(
          t("pages.CampanhasEspeciais.HenriqueJuliano.erroAoSolicitar")
        );
        return;
      }
    }

    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Approved
    ) {
      if (
        cashAdvanceAvailable === CashAdvanceAvailableEnum.Available ||
        cashAdvanceAvailable ===
          CashAdvanceAvailableEnum.GettingReleasesMetadata ||
        cashAdvanceAvailable !== CashAdvanceAvailableEnum.WaitingListAvailable
      ) {
        setOpenModalApproved(true);
        return;
      } else {
        history.push("/distribua", {
          specialCampaign: SpecialCampaignEnum.KamillaFialho,
        });
        return;
      }
    }

    if (
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Pending
    ) {
      setOpenModalRequest(true);
      return;
    }
  };

  const ModaisRender = () => (
    <>
      <Modais.ModalCampaignKFEligible
        open={openModalApproved}
        onCancel={() => setOpenModalApproved(false)}
      />
      <Modais.ModalCampaignKFNotEligible
        open={openModalNotElegible}
        onCancel={() => {
          removeSessionSpecialCampaign(SpecialCampaignEnum.KamillaFialho);
          setOpenModalNotElegible(false);
        }}
      />
      <Modais.ModalCampaignKFRequest
        open={openModalRequest}
        onCancel={() => setOpenModalRequest(false)}
      />
      <Modais.ModalCampaignKFResponse
        open={openModalResultRequest}
        onCancel={() => setOpenModalResultRequest(false)}
      />
    </>
  );

  const Content = () => (
    <div className="content">
      <h1>{title()}</h1>
      <h1 className="nome">Kamilla Fialho</h1>
      <p>{text()}</p>
      {!specialCampaign?.isParticipating && (
        <div className="botoes">
          <button className="botao-roxo" onClick={onClickIniciaProcesso}>
            {t("pages.EstagioArtista.queroFazerParte")}
          </button>
          <button className="botao-borda-roxa">
            <a
              href="https://kamillafialho.strmmusic.com"
              target="_blank"
              rel="noreferrer"
            >
              {t("pages.EstagioArtista.saibaMais")}
            </a>
          </button>
        </div>
      )}
    </div>
  );

  if (
    !specialCampaign ||
    specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Disapproved
  )
    return <ModaisRender />;

  if (mobile && isMobile) {
    return (
      <div className="cta-campanha-especial mobile">
        <ModaisRender />
        <img
          src={imgKamillaFialhoWeb}
          alt="Kamilla Fialho"
          className="image"
          style={{ top: -50 }}
        />
        {Content()}
      </div>
    );
  } else if (!mobile && !isMobile) {
    return (
      <div className="cta-campanha-especial web">
        <ModaisRender />
        {Content()}
        <img src={imgKamillaFialhoWeb} alt="Kamilla Fialho" className="image" />
      </div>
    );
  } else {
    return null;
  }
};

export default CardCTAKamillaFialho;
